"use client";

import { usePathname } from "@/i18n/navigation";
import { getRouteDetails } from "@/utils/routeHelper";
import clsx from "clsx";
import { useLocale } from "next-intl";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";
import DownloadAppBanner from "./DownloadAppBanner";
import Footer from "./Footer";
import Header from "./Header";

export default function LayoutWrapper({ children }) {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const routeDetails = getRouteDetails(pathname);
  const locale = useLocale();
  const {
    isPayment,
    isFlightResultPage,
    isReservation,
    isBusResultPage,
    isHotelResultPage,
    isAccountPage,
    isAboutUsPage,
    isAdvantagesPage,
    shouldHideFooter,
    shouldHideNavbar,
  } = routeDetails;

  const hideLayout = searchParams.get("hideLayout") === "true";
  const shouldHideLayout = hideLayout;

  let LayotWrapperClass =
    "flex min-h-screen flex-col overflow-hidden lg:overflow-visible";

  if (isBusResultPage || isHotelResultPage) {
    LayotWrapperClass =
      "flex min-h-screen flex-col overflow-hidden md:overflow-visible";
  }
  if (
    isFlightResultPage ||
    isHotelResultPage ||
    isAboutUsPage ||
    isAdvantagesPage
  ) {
    LayotWrapperClass = "flex min-h-screen flex-col";
  }

  // Otel arama sonuç sayfasında body scrollbar layout kaymasını önle
  useEffect(() => {
    const html = document.documentElement;
    if (isHotelResultPage) {
      html.classList.add("hotel-result-page");
    }
    return () => html.classList.remove("hotel-result-page");
  }, [isHotelResultPage]);

  return (
    <>
      <div
        className={clsx(
          LayotWrapperClass,
          isPayment || isAccountPage || pathname.includes("register")
            ? "bg-background-global pt-0"
            : "bg-white",
          shouldHideLayout ||
            isPayment ||
            pathname.includes("/bank-three-d-return")
            ? ""
            : "md:pt-[94px]",
          !shouldHideNavbar
            ? locale === "ar"
              ? "md:pr-[72px]"
              : "md:pl-[72px]"
            : "pl-0",
        )}
      >
        {!shouldHideLayout && <Header />}
        <div className="flex-grow">
          <main className={`mx-auto ${shouldHideLayout ? "p-0" : ""}`}>
            {children}
          </main>
        </div>
        {!shouldHideLayout && !shouldHideFooter && <Footer />}
      </div>
      {/* Mobil app yayına alındığında tekrardan gösterilecek, yorumlu alanı silmeyin */}
      {/* {!isReservation &&
        !isPayment &&
        !pathname.includes("/bank-three-d-return") && <DownloadAppBanner />} */}
    </>
  );
}
